(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setOpen(item, open) {
      var trigger = item.querySelector('[data-faq-trigger]');
      item.classList.toggle('is-open', open);
      if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeSiblings(item) {
      var root = item.closest('[data-faq-accordion]');
      if (!root || root.getAttribute('data-allow-multiple') === 'true') return;
      root.querySelectorAll('[data-faq-item].is-open').forEach(function (other) {
        if (other !== item) setOpen(other, false);
      });
    }

    document.addEventListener('click', function (evt) {
      var trigger = evt.target.closest('[data-faq-trigger]');
      if (!trigger) return;
      var item = trigger.closest('[data-faq-item]');
      if (!item) return;
      var open = !item.classList.contains('is-open');
      if (open) closeSiblings(item);
      setOpen(item, open);
    });

    // Theme editor: open the row whose block is selected
    document.addEventListener('shopify:block:select', function (evt) {
      var item = evt.target.closest ? evt.target.closest('[data-faq-item]') : null;
      if (!item) return;
      closeSiblings(item);
      setOpen(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
